import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { ShipperForm } from '@/services/shipper/schemas'
import BaseShipperForm from './BaseShipperForm'
import MultiplePlatformSection from './MultiplePlatformSection'
import { ShipperItem } from '@/services/shipper/types'

interface Props {
  type: 'create' | 'update'
  form: UseFormReturn<ShipperForm>
  onLogisticsServiceTypeChange?: (value: string) => void
}

function MWPShipperForm({ type, form, onLogisticsServiceTypeChange }: Props) {
  return (
    <div>
      <BaseShipperForm type={type} form={form as UseFormReturn<ShipperForm>} onLogisticsServiceTypeChange={onLogisticsServiceTypeChange} />
      <MultiplePlatformSection form={form as any} type={type} />
    </div>
  )
}

export default MWPShipperForm
